import { Accordion } from '../../../../../../components/general/accordion';
import ChatIcon from '@mui/icons-material/Chat';
import { Grid } from '@mui/material';
import FieldText from '../../../../../../components/general/fields/fieldText';
import { PqrClosingProps } from '../props';
import { usePqrObservationClose } from './hook';

export const PqrObservationClose = ({ closing }: PqrClosingProps) => {
    const { formik } = usePqrObservationClose(closing);

    return (
        <Accordion
            title="OBSERVACIÓN CIERRE"
            icon={<ChatIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12}>
                    <FieldText
                        label="Observación cierre"
                        name="observation"
                        rows={2}
                        value={formik.values.observation}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
